import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { api } from '../lib/api'
import { money, type Dashboard } from '../lib/types'

export function DashboardPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dashboard'],
    queryFn: () => api<Dashboard>('/admin/dashboard?days=30'),
  })

  if (isLoading) return <p className="muted">Загрузка…</p>
  if (error || !data) return <div className="error">{(error as Error)?.message || 'Ошибка'}</div>

  const kpis = [
    { label: 'Пользователи', value: data.users_total, sub: `+${data.users_today} сегодня` },
    { label: 'Активные 7д', value: data.users_active },
    { label: 'Проекты', value: data.orders_published, sub: `${data.orders_in_progress} в работе` },
    { label: 'Сделки активные', value: data.deals_active },
    { label: 'Сделки завершены', value: data.deals_completed },
    { label: 'Оборот', value: money(data.payments_sum) },
    { label: 'Верификация', value: data.identity_pending, sub: 'ожидают' },
  ]

  return (
    <div>
      <h1 className="page-title">Dashboard</h1>
      <p className="page-sub">Обзор платформы за последние 30 дней</p>

      <div className="grid-kpi">
        {kpis.map((k) => (
          <div className="card" key={k.label}>
            <div className="kpi-label">{k.label}</div>
            <div className="kpi-value">{k.value}</div>
            {k.sub && <div className="muted" style={{ marginTop: 4, fontSize: 12 }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      <div className="two-col">
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Регистрации</h3>
          <div style={{ width: '100%', height: 240 }}>
            <ResponsiveContainer>
              <AreaChart data={data.registrations_by_day}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                <Tooltip />
                <Area type="monotone" dataKey="count" stroke="#0037b0" fill="#bfdbfe" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Требует внимания</h3>
          <div className="attention">
            {data.attention.length === 0 && <p className="muted">Срочных задач нет</p>}
            {data.attention.map((a) => (
              <Link key={a.key} to={a.href}>{a.label}</Link>
            ))}
          </div>
          <h3>Проекты по дням</h3>
          <div style={{ width: '100%', height: 160 }}>
            <ResponsiveContainer>
              <AreaChart data={data.orders_by_day}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="date" hide />
                <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                <Tooltip />
                <Area type="monotone" dataKey="count" stroke="#0b7a52" fill="#bbf7d0" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  )
}
